import React from "react";
import linkdin from "../assets/imgs/linkedin-.png";
import git from "../assets/imgs/github.png";

const Header = () => {
  return (
    <div
      id="header"
      className="fixed top-0 left-0 z-50 w-full backdrop-blur-md"
    >
      <header className="mx-auto flex max-w-6xl flex-col items-center justify-between px-5 py-5 text-base font-medium text-white md:flex-row md:px-8 lg:px-10">
        <h1 className="text-center text-2xl font-semibold tracking-[0.08em] text-white">
          Bindu Lakkakula
        </h1>
        <ul className="mt-4 flex w-full justify-evenly text-sm uppercase tracking-[0.18em] text-zinc-300 md:mt-0 md:w-auto md:gap-8">
          <a href="#home">
            <li className="transition-colors duration-200 hover:text-white">
              Home
            </li>
          </a>
          <a href="#about">
            <li className="transition-colors duration-200 hover:text-white">
              About
            </li>
          </a>
          <a href="#projects">
            <li className="transition-colors duration-200 hover:text-white">
              Projects
            </li>
          </a>
          <a href="#contact">
            <li className="transition-colors duration-200 hover:text-white">
              Contact
            </li>
          </a>
        </ul>
        <div className="w-fit flex justify-evenly align-baseline mt-3 gap-5 items-center">
      <a
        href="https://www.linkedin.com/in/bindu-lakkakula/"
        target="_blank"
        rel="noreferrer"
      >
        <img className=" h-10 w-10 rounded-lg bg-white p-1" src={linkdin} alt="linkdin" />
      </a>
      <a
        className=""
        href="https://github.com/binduthotal"
        target="_blank"
        rel="noreferrer"
      >
        <img className="h-10 w-10 rounded-lg bg-gray-100 p-1" src={git} alt="GitHub" />
      </a>
    </div>
      </header>
    </div>
  );
};

export default Header;
